<template>
    <div id="select-medication-dialog" class="select-button d-flex">
        <div class="medication-badges-container d-flex flex-wrap" @click="showDialog" @keyup.enter="showDialog"
             tabindex="0">
            <span v-show="!selectedValue.length" class="placeholder">
                {{label ? label : "Gyógyszer"}}
            </span>
            <div v-for="item in selectedValue" :key="item.idTermek">
                <div>
                    <span class="badge badge-info" @click.stop>
                        {{ options.formatText(item) }}
                        <i class="fas fa-times badge-remove" @click.stop="removeRow(item)"></i>
                    </span>
                <label class="smooth-label" :class="{'required': required}">{{label ? label : "Gyógyszer"}}</label>
                </div>
            </div>
        </div>

        <div class="align-items-center d-flex search-icon-wrapper" @click="showDialog">
            <span><i class="fas fa-search"></i></span>
        </div>

        <b-modal id="medication-select-modal" size="xl" lazy ref="medication-select-dialog" title="Gyógyszer(ek) kiválasztása">
            <b-tabs content-class="mt-3" lazy>
                <b-tab title="Összes" active>
                    <div class="d-block" :style="cssVars">
                        <DataTable ref="dataTable"
                                   :columns="getHeaderFields"
                                   :additional-config="getDataTableOptions"
                                   :apiCallback="getValidMedications"
                                   @customClick="buttonWasClicked">
                        </DataTable>
                    </div>
                </b-tab>
                <!-- <b-tab title="Összes">
                    <div class="d-block" :style="cssVars">
                        <DataTable ref="dataTable"
                                   :columns="getHeaderFields.filter(field => field.name !== 'buttons')"
                                   :additional-config="getDataTableOptions"
                                   :apiCallback="getAllBNO"
                                   @customClick="buttonWasClicked"/>
                    </div>
                </b-tab> -->
            </b-tabs>

            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button size="sm" variant="danger" @click="hideDialog">
                    <i class="far fa-times-circle"></i> Bezár
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import Api from "../util/Api";
    import {mapGetters} from "vuex";
    import DataTable from "../components/DataTable";
    import SelectComponent from "@/components/SelectComponent";

    export default {
        name: "SelectMedicationMultiDialog",
        components: {
            DataTable,
            SelectComponent
        },
        data() {
            return {
                selectedValue: []
            }
        },
        props: {
            value: {type: Array},
            options: {type: Object},
            required: {type: Boolean, default: false},
            label: {type: String, default: null},
            readOnly: {type: Boolean, default: false},
        },
        computed: {
            ...mapGetters("medicationSelectDialog", ["getDataTableOptions"]),
            ...mapGetters("app", ['getDefaultColor']),
            getHeaderFields: function() {
                return  [
                    {
                        name: "idTermek",
                        label: "ID",
                        visibility: false
                    },
                    {
                        name: "nev",
                        label: "Gyógyszer neve",
                        filter: {
                            type: "simple",
                        },
                        sort: true,
                        visibility: true
                    },
                    {
                        name: "buttons",
                        label: "Opciók",
                        values: this.value,
                        slot_name: "row_select",
                        sort: false,
                        visibility: true
                    }
            ]},

            cssVars() {
                return {
                    '--default-color': this.getDefaultColor
                }
            },
        },
        methods: {
            showDialog() {
                if (!this.readOnly) {
                    this.$refs['medication-select-dialog'].show();
                }
            },
            hideDialog() {
                this.$refs['medication-select-dialog'].hide();
            },

            selectRow(rowData) {
                this.selectedValue.push(rowData);
                this.$emit('input', this.selectedValue);
            },

            removeRow(data) {
                this.selectedValue = this.selectedValue.filter((item) => data.idTermek !== item.idTermek);
                this.$emit('input', this.selectedValue);
            },


            // getValidIllness(params) {
            //     params.params.filter = {
            //         ...params.params.filter
            //     };
            //     return Api.getDrugByFilter(params);
            // },
            getValidMedications(params) {
                params.params.filter = {
                    ...params.params.filter,
                    ...this.searchFormData
                };
                return Api.getAllPuphaxTermek(params);
            },

            refreshGrid() {
                this.$refs.dataTable.fetchData();
            },

            buttonWasClicked(event, data) {
                switch (event.event_payload) {
                    case "selectRow":
                        this.selectRow(data);
                        break;
                    case "removeRow":
                        this.removeRow(data);
                        break;
                }
            }

        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler: function (val) {
                    if (val) {
                        this.selectedValue = val;
                    }
                }
            }
        }
    }
</script>

<style scoped>
</style>
